import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { articleList } from "@/mocks/article";

export default function ArticlesSection() {
  const { t, i18n } = useTranslation();

  return (
    <section id="articles" className="w-full bg-background-50">
      <div className="mx-auto max-w-6xl px-4 md:px-6 py-14 md:py-20">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
            {t("articles.title")}
          </h2>
          <p className="mt-3 text-sm md:text-base text-foreground-600 max-w-2xl mx-auto">
            {t("articles.subtitle")}
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {articleList.map((article) => (
            <Link
              key={article.slug}
              to={`/${i18n.language}/article/${article.slug}`}
              className="group flex flex-col overflow-hidden rounded-2xl border border-background-200 bg-background-50 hover:border-primary-300 transition-all cursor-pointer"
            >
              <div className="relative h-44 overflow-hidden">
                <img
                  src={article.image}
                  alt={t(`article.${article.id}.title`)}
                  className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
                <span className="absolute top-3 left-3 rounded-full bg-accent-500 text-background-50 text-xs font-bold px-3 py-1">
                  {article.category}
                </span>
              </div>
              <div className="flex flex-col flex-1 p-5">
                <h3 className="font-heading text-base md:text-lg font-bold text-foreground-950 leading-snug">
                  {t(`article.${article.id}.title`)}
                </h3>
                <p className="mt-2 text-sm text-foreground-600 leading-relaxed flex-1">
                  {t(`article.${article.id}.excerpt`)}
                </p>
                <span className="mt-4 inline-flex items-center gap-2 text-sm font-bold text-primary-600">
                  {t("articles.readMore")}
                  <span className="w-4 h-4 flex items-center justify-center">
                    <i className="ri-arrow-right-line text-sm"></i>
                  </span>
                </span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}